export const menuConfig = [
  {
    id: 1,
    name: "ADMINISTRATION",
    menus: [{ id: 1, name: "Manage Users", isChecked: false }],
    isChecked: false,
  },
  {
    id: 2,
    name: "ONBOARDING",
    menus: [
      { id: 1, name: "Onboarding Form", isChecked: false },
      {
        id: 2,
        name: "Contract Management",
        isChecked: false,
      },
      { id: 3, name: "ACH Information", isChecked: false },
      { id: 4, name: "Insurance Information", isChecked: false },
      // { id: 5, name: "Background Check", isChecked: false },
      { id: 6, name: "Check Onbording Status", isChecked: false },
      // { id: 7, name: "Reporting Details", isChecked: false },
      // { id: 8, name: "Time Logs", isChecked: false },
      // { id: 9, name: "Compliance", isChecked: false },
      { id: 10, name: "List of Candidates", isChecked: false },
      { id: 11, name: "Invoice and Payments", isChecked: false },
    ],
    isChecked: false,
  },
];
